// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "node_modules_quill_quill_js") return "js/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};